import { QUERY_KEYS } from 'src/services/consts/queries.const'

/**
 * Slack connect or disconnect changes the preferences on the backend, and the Slack responses
 * lack them. Marks the preferences cache stale without a refetch; the next open of the
 * Notifications tab refetches. Cancels an in-flight fetch first: a fetch that succeeds after
 * the mark would clear it and keep the old lists. A first load is never cancelled, so the page
 * never sits pending without data.
 *
 * @param {import('@tanstack/vue-query').QueryClient} queryClient
 */
export async function markNotificationPreferencesStale(queryClient) {
  const queryKey = [QUERY_KEYS.NOTIFICATION_PREFERENCES]
  await queryClient.cancelQueries({
    queryKey,
    predicate: (query) => query.state.data !== undefined,
  })
  await queryClient.invalidateQueries({ queryKey, refetchType: 'none' })
}
